import type { IconComponent } from '@consta/icons/Icon'
import { Text } from '@consta/uikit/Text'
import {
  searchInCategory,
  selectActiveProjectName,
  selectSearchActiveCategoryId,
  selectSearchResults,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { OverallSearchResultCategory } from '@core/core/types'
import { getFolderSelectionParams } from '@core/core/utils'
import { useSpa } from '@core/hooks'
import { IconActiveFolder, IconFolderWell } from '@core/icons'
import cn from 'classnames'
import type { FC } from 'react'

import css from './FoundEntitiesList.css'
import type { FoundEntitiesListProps as Props } from './types'

const getIcon = (item: OverallSearchResultCategory): IconComponent => {
  if (item.source === 'geodb') {
    return IconFolderWell
  }

  return IconActiveFolder
}
const nameFieldWidth = { lineHeight: '2.4rem' }
const textStyle = { lineHeight: '2.4rem', flex: '0 0 3.2rem' }

export const FoundEntitiesList: FC<Props> = ({ projectId }) => {
  const dispatch = useAppDispatch()
  const activeCategoryId = useAppSelector(selectSearchActiveCategoryId)
  const activeProjectName = useAppSelector(selectActiveProjectName)
  const results = useAppSelector(selectSearchResults)
  const sendSpaEvent = useSpa()

  const onNodeSelect = (item: OverallSearchResultCategory) => {
    if (item.id === activeCategoryId) return

    if (activeProjectName) {
      sendSpaEvent(
        'new import_add file to project',
        getFolderSelectionParams(item.name, activeProjectName),
      )
    }

    dispatch(searchInCategory({ projectId, activeCategory: item }))
  }

  return (
    <div className={css.container}>
      {results.map(item => {
        const { id, name, count } = item
        const Icon = getIcon(item)

        const itemClassName = cn({ [css.itemActive]: activeCategoryId === id }, css.item)
        return (
          <div
            key={id}
            className={itemClassName}
            onClick={() => {
              onNodeSelect(item)
            }}>
            <div className={css.iconWrapper}>
              <Icon size="s" />
            </div>
            <Text
              className={css.name}
              view="primary"
              size="xs"
              style={nameFieldWidth}
              truncate={true}>
              {name}
            </Text>
            <Text className={css.count} size="xs" style={textStyle} align="right" view="ghost">
              {count}
            </Text>
          </div>
        )
      })}
    </div>
  )
}
